import React from 'react';

const Blog = () => {
  return (
    <section className="relative min-h-screen  flex flex-col items-center justify-center overflow-hidden">
      <p>Welcome to the blog!</p>
      <p>Blog coming soon...</p>
    </section>
  );
};

export default Blog;
